<script>
import axios from '@/utils/axios';

export default {
inject: ['setLoading'],    
 data() {
  return { 
   title: "CRM",
   text: "CRM",
   total: 0,
   data: [],
   searchText: '', 
   columns: [
      {
        title: 'S.No',
        dataIndex: 'SNo',
        key: 'SNo',
      },
      {
        title: 'Group Name',
        dataIndex: 'GroupName',
        key: 'GroupName',
      },
      {
        title: 'Actions',
        key: 'action',
      },
    ],
    rowSelection: null,
  };
},

computed: {
  text1(){
   return `Items Groups (${this.total})`; 
  },
  filteredData() {
    if (!this.searchText) return this.data;
    const search = this.searchText.toLowerCase();
    return this.data.filter(item => item.name?.toLowerCase().includes(search));
  },
},

mounted() {
 this.itemGroups();
}, 

methods: {
  async itemGroups(){
    this.setLoading(true);
    try{
     const response = await axios.get('/item-groups');
     this.data = response.data.data;
     this.total = this.data.length;
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
  }
},
};
</script>
<style scoped>
/* Ant Design table → Card-like rows */
:deep(.ant-table) {
  background: #f1f5f9 !important;
}
:deep(.ant-table-container) {
  background: #f1f5f9 !important;
}
:deep(.ant-table-thead > tr > th) {
  background: #fff !important;
  font-size: 10.5px !important;
  font-weight: 700 !important;
  color: #000 !important;
  text-transform: uppercase !important;
  letter-spacing: .6px !important;
  border-bottom: none !important;
  padding: 14px !important;
}
:deep(.ant-table-thead > tr > th:first-child) {
  border-radius: 10px 0 0 10px !important;
}
:deep(.ant-table-thead > tr > th:last-child) {
  border-radius: 0 10px 10px 0 !important;
}

/* Body rows */
:deep(.ant-table-tbody > tr > td) {
  background: #fff !important;
  padding: 13px 14px !important;
  font-size: 12.5px !important;
  border-bottom: 6px solid #f1f5f9 !important;
  transition: all .15s !important;
}
:deep(.ant-table-tbody > tr > td:first-child) {
  border-radius: 10px 0 0 10px !important;
  border-left: 1px solid #e8edf3 !important;
}
:deep(.ant-table-tbody > tr > td:last-child) {
  border-radius: 0 10px 10px 0 !important;
  border-right: 1px solid #e8edf3 !important;
}

/* Hover */
:deep(.ant-table-tbody > tr:hover > td) {
  background: #f8faff !important;
  border-color: #c7d2fe !important;
}

/* Remove default ant stripe/border */
:deep(.ant-table-tbody > tr > td) {
  border-top: none !important;
}
</style>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
<breadcrumb :title="title" :text="text" :text1="text1" />
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
<div class="mb-2">
<a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#group_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.itemGroupModal.add();"><i class="ti ti-circle-plus me-2"></i>Add Group</a>
</div>

</div>
</div>
<!-- /Breadcrumb -->

<div class="card">
<div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
<h5>Item Groups List</h5>
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
<!-- <div class="dropdown">
 <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown">
    Sort By : Last 7 Days
    </a>
    <ul class="dropdown-menu dropdown-menu-end p-3">
    <li>
        <a href="javascript:void(0);" class="dropdown-item rounded-1">Recently Added</a>
    </li>
    <li>
        <a href="javascript:void(0);" class="dropdown-item rounded-1">Ascending</a>
    </li>
    <li>
        <a href="javascript:void(0);" class="dropdown-item rounded-1">Desending</a>
    </li>
    <li>
        <a href="javascript:void(0);" class="dropdown-item rounded-1">Last Month</a>
    </li>
    <li>
        <a href="javascript:void(0);" class="dropdown-item rounded-1">Last 7 Days</a>
    </li>
    </ul>
</div> -->

<div class="">
  <a-input v-model:value="searchText" placeholder="Search group name..." allow-clear style="width: 300px;"/>
</div>

</div>
</div>
<div class="card-body card-table-wrapper">
<div class="custom-datatable-filter table-responsive">

<a-table v-if="filteredData.length" class="table datatable thead-light" :columns="columns" :data-source="filteredData"
  :row-selection="rowSelection">
  <template #bodyCell="{ column, record, index }">
    <template v-if="column.key === 'SNo'"> {{ index + 1 }}. </template>   
    <template v-if="column.key === 'GroupName'">
      <h6 class="fs-14 fw-medium">
        <router-link to="#">{{ record.name }}</router-link>
      </h6>
    </template>
    <template v-if="column.key === 'action'">
      <div class="action-icon d-inline-flex">
        <a href="javascript:void(0);" class="me-2" data-bs-toggle="modal" data-bs-target="#group_modal" @click="$refs.itemGroupModal.group(record.id)">
          <i class="ti ti-edit"></i>
        </a>
        <a href="javascript:void(0);" class="text-danger" data-bs-toggle="modal" data-bs-target="#delete_modal" @click="$refs.itemGroupModal.group(record.id)">
          <i class="ti ti-trash"></i>
        </a>
      </div>
    </template>
  </template>
</a-table>

<div v-else class="p-3 text-center text-muted">
  No records found.
</div>

</div>
</div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<item-group-modal ref="itemGroupModal" @updated="itemGroups"></item-group-modal>
</template>
